import { hwbaseApi, o2oApi } from 'yxt-biz-pc/packages/api';

/**
 * 获取文件播放地址列表
 * 沿用以前的接口传参，video 的时候 为1 没看懂
 * @returns
 */
export const getFilePlayUrls = (fileId, type) =>
  hwbaseApi.get(
    `attachment/play-list?fileId=${fileId}&clientType=${
      type === 'video' ? 1 : ''
    }`
  );

/**
 * 获取文件转码状态
 * @param {String} fileId:
 * @returns
 */
export const getFileTranscodeState = fileId =>
  hwbaseApi.get(`attachment/status?fileId=${fileId}`);

/**
 * 获取文件下载 地址
 * @param {String} fileId
 * @returns
 */
export const getFileDownloadUrl = fileId =>
  hwbaseApi.get(`attachment/download?fileId=${fileId}`);

// 获取附件地址
export const postThirdUrl = (fileId, type, config) => {
  return o2oApi.post(
    `third/file/${fileId}${type === 'video' ? '?clientType=1' : ''}`,
    config
  );
};

// check附件转码状态 taskType  6 表示 作业引擎的文件
export const postCheckFileStatus = (fileId, taskType = '') => {
  return o2oApi.get(`/attachment/get/status/${fileId}?taskType=${taskType}`);
};

// 下载文件
export const putThirdUrl = fileId => {
  return o2oApi.put(`third/file/${fileId}`);
};
